import * as React from 'react';
import { GeoJSON, DivIcon } from 'leaflet';
import { Marker, Popup, TileLayer } from 'react-leaflet';
import * as d3 from 'd3';
import 'leaflet/dist/leaflet.css';

import { Answer } from '../domain.js';
import { config } from '../config.js';

// Create a color scale for moderation ratings (assuming ratings are between 0-1)
const colorScale = d3.scaleSequential()
  .domain([0, 5])
  .interpolator(d3.interpolateYlOrRd)

const createCircleMarker = (rating: number, redactedTranscriptLength: number) => {
  const color = colorScale(rating);
  const radius = Math.min(100, (redactedTranscriptLength / 100) +2); // Scale radius based on redactedTranscriptLength, capped at 8
  // console.log("radius", radius, redactedTranscriptLength);
  const svg = `
    <svg width="${radius * 2}" height="${radius * 2}" viewBox="0 0 ${radius * 2} ${radius * 2}" xmlns="http://www.w3.org/2000/svg">
      <circle cx="${radius}" cy="${radius}" r="${radius}" fill="${color}" opacity="0.3" />
    </svg>
  `;

  return new DivIcon({
    html: svg,
    className: 'circle-marker',
    iconSize: [radius * 2, radius * 2],
    iconAnchor: [radius, radius],
    popupAnchor: [0, -radius],
  });
};

export const MapTileLayer = () => {
  const apiKey = config.stadiaMapsApiKey;
  const url = apiKey 
    ? `https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=${apiKey}`
    : `https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png`;
  
  return (
    <TileLayer
      url={url}
      minZoom={0}
      maxZoom={20}
      attribution='&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    />
  );
};

export const MapAnswerMarker: React.FC<{ answer: Answer }> = ({ answer }) => (
  <Marker position={[answer.location.coordinates[1], answer.location.coordinates[0]]}>
    <Popup>
      {answer.transcript}
    </Popup>
  </Marker>
);

export const MapRatedAnswerMarker: React.FC<{ answer: Answer }> = ({ answer }) => {
  const redactedTranscriptLength = answer.redacted_transcript ? answer.redacted_transcript.length + 200 : 200;
  const markerIcon = createCircleMarker(answer.moderation_rating ?? 0, redactedTranscriptLength);

  return (
    <Marker
      key={answer.id}
      position={GeoJSON.coordsToLatLng(answer.location.coordinates)}
      icon={markerIcon}
    >
      <Popup>
        <p>{answer.question_id}</p>
        <div style={{ maxHeight: '20vh', overflowY: 'auto', marginBottom: '10px' }}>
          <p>Transcript: {answer.transcript}</p>
        </div>
        <audio src={answer.processed_audio} controls />
      </Popup>
    </Marker>
  );
};